import ProfileLayout from '../modules/Profile/ProfileLayout';
import PinCode from '../modules/Profile/PinCode';
import { CustomNextPage } from '../lib/types';
import { profilePageQuery } from '../core-types';
import { PROFILE_PAGE_QUERY } from '../modules/Profile/graphql';
import { bootstrap } from '../lib/bootstrap';

const PinCodePage: CustomNextPage<{
  statusCode?: number;
}> = props => {
  const { url, statusCode } = props;
  return (
    <ProfileLayout url={url} statusCode={statusCode}>
      {() => {
        return <PinCode />;
      }}
    </ProfileLayout>
  );
};

PinCodePage.getInitialProps = async ctx => {
  const profilePageQueryResult = await ctx.apolloClient.query<profilePageQuery>(
    {
      query: PROFILE_PAGE_QUERY
    }
  );
  let statusCode;
  if (!profilePageQueryResult.data?.profilePage) {
    statusCode = 404;
    if (ctx.res) {
      // eslint-disable-next-line require-atomic-updates
      ctx.res.statusCode = statusCode;
    }
  }

  return {
    statusCode
  };
};

export default bootstrap(PinCodePage);
